import styled from 'styled-components';

export const ParagraphWrapper = styled.p`
  margin-bottom: 0rem;
  margin-top: 0rem;
`;

export const BottomSpacer = styled.div`
  margin-bottom: 1rem;
  margin-top: 0rem;
`;

export const ParagraphSpacer = styled.p`
  margin-bottom: 1rem;
  margin-top: 1rem;
`;

export const OrderedListWrapper = styled.ol`
    margin-bottom: 0rem;
    margin-top: 0rem;
`
